module.exports = __webpack_public_path__ + "a3f07e3e1ccef681e708751254c9d40f.svg";